<script>
import Config from '@/config';
import FormMinx from '@/mixins/form';
import AdminMinx from '@/mixins/admin';
import {Uploader, Popup, DatetimePicker, RadioGroup, Radio, Toast} from 'vant';
import {getStationBaseInfo, getStationCheckItems, createStationCheckRecord, getStationCheckRecordDetail} from '@/api';

export default {
  mixins: [
    FormMinx,
    AdminMinx
  ],
  components: {
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  data() {
    return {
      stationName: '',
      checkItemGroup: [],

      checkAt: null,
      checkType: 1,
      items: {},
      remark: null,
      operatorOnDuty: null,
      recordPeople: null,
      images: {},
    };
  },
  computed: {
    dayCheckId() {
      return this.$route.params.dayCheckId;
    },
    stationCode() {
      return this.$route.params.stationCode;
    },
    readonly() {
      return !!this.$route.params.dayCheckId;
    }
  },
  watch: {
    stationCode(value) {
      this.loadStationData(value);
    },
    dayCheckId(value) {
      this.loadDayCheckData(value);
    }
  },
  created() {
    this.loadStationData(this.stationCode);
    this.loadDayCheckData(this.dayCheckId);
  },
  methods: {
    loadStationData(value) {
      if (value) {
        getStationBaseInfo(value).then(response => {
          this.stationName = response.data.body.name;
        });

        getStationCheckItems(value).then(response => {
          response.data.body.forEach(value => {
            this.$set(this.images, 'images_' + value.type, [])
            value.items.forEach(v => {
              this.$set(this.items, 'item_' + value.type + '_' + v.key + '_' + v.value, null)
            });
          });
          this.checkItemGroup = response.data.body;
        });
      } else {
        this.stationName = null;
        this.checkItemGroup = [];
      }
    },
    loadDayCheckData(value) {
      this.showDatetimePicker = false;

      if (value) {
        getStationCheckRecordDetail(value).then(response => {
          this.checkAt = response.data.body.checkAt;
          this.checkType = response.data.body.checkType;
          this.remark = response.data.body.remark;
          this.operatorOnDuty = response.data.body.operatorOnDuty;
          response.data.body.checkItems.filter(v => v.id !== 0).forEach(v => {
            this.$set(this.items, 'item_' + v.type + '_' + v.id, Number(v.value))
          });
          response.data.body.checkItems.filter(v => v.id === 0).forEach(v => {
            this.$set(this.images, 'images_' + v.type, v.value ? v.value.split(',').map(url => {
              return {url: url, isImage: true, deletable: !this.readonly};
            }) : [])
          });
        });
      } else {
        this.checkAt = null;
        this.checkType = 1;
        this.remark = null;
        this.operatorOnDuty = null;
        this.items = {};
        this.images = {};
      }
    },
    onSubmit(values) {
      let data = {
        checkAt: this.checkAt,
        checkType: this.checkType,
        remark: this.remark,
        operatorOnDuty: this.operatorOnDuty,
        checkItems: []
      };
      Object.keys(values).forEach(key => {
        if (key.startsWith('item')) {
          let arr = key.split('_');
          data.checkItems.push({id: Number(arr[2]), type: Number(arr[1]), value: values[key], name: arr[3]})
        } else if (key.startsWith('images')) {
          let arr = key.split('_');
          data.checkItems.push({id: 0, type: Number(arr[1]), value: values[key].map(v => v.objectKey).join(','), name: '图片'})
        }
      });
      createStationCheckRecord(this.stationCode, data).then(response => {
        if (response.data.code === Config.successCode) {
          Toast('创建检查记录成功');
          this.$router.go(-1);
        } else {
          Toast('创建检查记录失败');
        }
      }).catch(() => Toast('创建检查记录失败'));
    },
    datetimePickerOnConfirm(datetime) {
      this.showDatetimePicker = false;
      this.checkAt = datetime.format('yyyy-MM-dd hh:mm');
    }
  }
}
</script>

<template>
  <van-form @submit="onSubmit" :show-error-message="false">
    <div class="row-title">{{ stationName }}</div>
    <van-field :value="checkAt" name="checkAt" label="检查时间" placeholder="点击选择检查时间" @click="showDatetimePicker = true" :rules="[{ validatorDatetime }]" :readonly="readonly" clickable/>
    <van-field name="checkType" label="检查类型" :readonly="readonly">
      <template #input>
        <van-radio-group v-model="checkType" direction="horizontal">
          <van-radio :name="1">日常</van-radio>
          <van-radio :name="2">交班</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <template v-for="group in checkItemGroup">
      <div v-if="group.type === 1" class="row-title">场站清洁</div>
      <div v-else-if="group.type === 2" class="row-title">设备检查</div>
      <div v-else></div>
      <van-field v-for="item in group.items" :key="item.id" :name="'item_'+ group.type + '_' + item.key + '_' + item.value" :label="item.value" :readonly="readonly">
        <template #input>
          <van-radio-group v-model="items['item_' + group.type + '_' + item.key]" direction="horizontal">
            <van-radio :name="1">
              <template v-if="group.type === 1">
                合格
              </template>
              <template v-if="group.type === 2">
                完好
              </template>
              <template v-else></template>
            </van-radio>
            <van-radio :name="2">
              <template v-if="group.type === 1">
                不合格
              </template>
              <template v-if="group.type === 2">
                故障
              </template>
              <template v-else></template>
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div class="row-title-small">上传照片</div>
      <van-field :name="'images_' + group.type" :readonly="readonly" label-width="0">
        <template #input>
          <van-uploader v-model="images['images_' + group.type]" :before-read="uploadBeforeRead" :after-read="uploadAfterRead" :before-delete="uploadBeforeDelete" :deletable="!readonly" :show-upload="!readonly" multiple/>
        </template>
      </van-field>
    </template>
    <van-field v-model="remark" name="remark" label="备注" placeholder="请填写备注" :rules="[{ required: true, message: '备注不能为空' }]" :readonly="readonly"/>
    <van-field v-model="operatorOnDuty" name="operatorOnDuty" label="值班人员" placeholder="请填写值班人员" :rules="[{ required: true, message: '值班人员不能为空' }]" :readonly="readonly"/>
    <van-field name="recordPeople" :value="recordPeople ? recordPeople : mobile" label="登记人员" :readonly="readonly"/>
    <div v-if="!readonly" class="from-submit">
      <van-button round block type="info" native-type="submit">提交</van-button>
    </div>
    <van-popup v-if="!readonly" v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker type="datetime" :min-date="minDate" :max-date="maxDate" @confirm="datetimePickerOnConfirm" @cancel="showDatetimePicker = false" :formatter="datetimeFormatter"/>
    </van-popup>
  </van-form>
</template>

<style scoped>

</style>
